import { ClientConfigProductName } from '@frontend/vanilla/core';

export const QuickLinkLoader = {
    id: 'quick-links',
    loaderFn: () => import(/* webpackChunkName: "ms-quick-links" */ './quick-links.feature'),
    product: ClientConfigProductName.SPORTS,
};
